import { render, staticRenderFns } from "./TeacherDetails.vue?vue&type=template&id=8c04e3c2&"
import script from "./TeacherDetails.vue?vue&type=script&lang=ts&"
export * from "./TeacherDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports